module.exports = __webpack_public_path__ + "static/media/atacado_fundo_branco.dae4e1bb.png";